// extracted by mini-css-extract-plugin
export default {"base":"vp_cio_1","content":"vp_VyGVR"};